import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function AGB() {
  return (
    <div className="pt-32 pb-24" data-testid="agb-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex items-center gap-2 text-sm mb-8">
          <Link to="/" className="text-[#c8c6c4] hover:text-[#d1af6a]">Home</Link>
          <ChevronRight className="w-4 h-4 text-[#c8c6c4]" />
          <span className="text-[#d1af6a]">AGB</span>
        </nav>

        <h1 className="font-display text-4xl text-white mb-8">Allgemeine Geschäftsbedingungen</h1>

        <div className="prose prose-invert prose-p:text-[#c8c6c4] prose-headings:text-white prose-headings:font-subheading prose-li:text-[#c8c6c4] max-w-none space-y-8">
          <section>
            <h2>§ 1 Geltungsbereich</h2>
            <p>
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen 
              Serdar Dogan, Dogan Immobilien (nachfolgend „Makler") und dem Auftraggeber 
              (nachfolgend „Kunde") über Maklerleistungen im Bereich Immobilien geschlossen werden.
            </p>
          </section>

          <section>
            <h2>§ 2 Vertragsgegenstand</h2>
            <p>
              Gegenstand des Maklervertrages ist die Vermittlung von Immobilien zum Kauf oder zur 
              Miete sowie die Erstellung von Wertgutachten und Immobilienbewertungen. Der genaue 
              Leistungsumfang ergibt sich aus der individuellen Vereinbarung mit dem Kunden.
            </p>
          </section>

          <section>
            <h2>§ 3 Provisionspflicht</h2>
            <p>
              Die Maklerprovision wird fällig, wenn durch die Vermittlung oder den Nachweis des 
              Maklers ein Hauptvertrag (Kauf- oder Mietvertrag) zustande kommt. Die Höhe der 
              Provision wird individuell vereinbart und entspricht den marktüblichen Sätzen.
            </p>
            <p>
              Bei Kaufobjekten beträgt die übliche Provision für den Käufer [X]% des Kaufpreises 
              zzgl. der gesetzlichen Mehrwertsteuer. Bei Mietobjekten beträgt die Provision 
              [X] Monatsmieten zzgl. der gesetzlichen Mehrwertsteuer.
            </p>
          </section>

          <section>
            <h2>§ 4 Pflichten des Kunden</h2>
            <p>Der Kunde verpflichtet sich:</p>
            <ul>
              <li>Alle für die Vermittlung relevanten Informationen wahrheitsgemäß und vollständig mitzuteilen</li>
              <li>Den Makler unverzüglich über einen erfolgten Vertragsabschluss zu informieren</li>
              <li>Exposés und andere vom Makler überlassene Unterlagen vertraulich zu behandeln und nicht ohne Zustimmung an Dritte weiterzugeben</li>
            </ul>
          </section>

          <section>
            <h2>§ 5 Pflichten des Maklers</h2>
            <p>
              Der Makler verpflichtet sich, die Interessen des Kunden nach bestem Wissen und 
              Gewissen zu vertreten und alle ihm bekannten, für die Entscheidung des Kunden 
              wesentlichen Umstände mitzuteilen.
            </p>
          </section>

          <section>
            <h2>§ 6 Haftung</h2>
            <p>
              Der Makler haftet nur für vorsätzlich oder grob fahrlässig verursachte Schäden. 
              Die Haftung für Angaben zur Immobilie beschränkt sich auf die Weitergabe der vom 
              Eigentümer erhaltenen Informationen. Eine eigene Prüfpflicht des Maklers besteht 
              nur in Ausnahmefällen.
            </p>
          </section>

          <section>
            <h2>§ 7 Widerrufsrecht</h2>
            <p>
              Verbrauchern steht bei außerhalb von Geschäftsräumen geschlossenen Verträgen und 
              bei Fernabsatzverträgen ein Widerrufsrecht zu. Die Widerrufsbelehrung wird dem 
              Kunden gesondert zur Verfügung gestellt.
            </p>
          </section>

          <section>
            <h2>§ 8 Datenschutz</h2>
            <p>
              Die Erhebung und Verarbeitung personenbezogener Daten erfolgt gemäß unserer 
              Datenschutzerklärung, die auf unserer Website einsehbar ist.
            </p>
          </section>

          <section>
            <h2>§ 9 Schlussbestimmungen</h2>
            <p>
              Es gilt deutsches Recht. Gerichtsstand für alle Streitigkeiten aus diesem Vertrag 
              ist, soweit gesetzlich zulässig, der Sitz des Maklers.
            </p>
            <p>
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die 
              Wirksamkeit der übrigen Bestimmungen unberührt.
            </p>
          </section>

          <p className="text-sm text-[#c8c6c4]/60 mt-12">
            Stand: Dezember 2024
          </p>
        </div>
      </div>
    </div>
  );
}
